/**
 * Utility functions for browser detection and handling browser-specific behaviors
 */

/**
 * Detects if the current browser is Chrome
 * @returns boolean indicating if the browser is Chrome
 */
export function isChromeBrowser(): boolean {
  return navigator.userAgent.indexOf('Chrome') !== -1 && 
         navigator.userAgent.indexOf('Edg') === -1 &&  // Not Edge
         navigator.userAgent.indexOf('OPR') === -1;    // Not Opera
}

/**
 * Detects if the current browser is Firefox
 * @returns boolean indicating if the browser is Firefox
 */
export function isFirefoxBrowser(): boolean {
  return navigator.userAgent.indexOf('Firefox') !== -1;
}

/**
 * Detects if the current browser is Safari
 * @returns boolean indicating if the browser is Safari
 */
export function isSafariBrowser(): boolean {
  return navigator.userAgent.indexOf('Safari') !== -1 && 
         navigator.userAgent.indexOf('Chrome') === -1;
}

/**
 * Detects if the current browser is Edge
 * @returns boolean indicating if the browser is Edge
 */
export function isEdgeBrowser(): boolean {
  return navigator.userAgent.indexOf('Edg') !== -1;
}

/**
 * Detects if the current browser is Opera
 * @returns boolean indicating if the browser is Opera
 */
export function isOperaBrowser(): boolean {
  return navigator.userAgent.indexOf('OPR') !== -1;
}

/**
 * Detects if the current browser is DuckDuckGo
 * @returns boolean indicating if the browser is DuckDuckGo
 */
export function isDuckDuckGoBrowser(): boolean {
  return navigator.userAgent.indexOf('DuckDuckGo') !== -1;
}

/**
 * Gets the current browser name
 * @returns string with the browser name
 */
export function getBrowserName(): string {
  if (isChromeBrowser()) return 'Chrome';
  if (isFirefoxBrowser()) return 'Firefox';
  if (isSafariBrowser()) return 'Safari';
  if (isEdgeBrowser()) return 'Edge';
  if (isOperaBrowser()) return 'Opera';
  if (isDuckDuckGoBrowser()) return 'DuckDuckGo';
  return 'Unknown';
}
